import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ChaletIcon(props: IconProps) {
    return <Icon {...props} iconKey={"chalet"}/>
}
